var validate = require('./actions/validate');
var surveyUtils = require('../../modules/survey/utils');
var _ = require('lodash');

var responseUtils = (function() {

    var _isValidAnswer = function(responses, field, dispatch) {
        const { currentResponse, submission } = responses;
        const questionRows = field.rows || surveyUtils.getPriorResponse(field, submission);

        if(field.type !== 'text' && field.type !== 'transition' && currentResponse.length === 0) {
            dispatch(validate.setResponseValidationError({message: "An answer is required in order to proceed."}));
            return false;
        } else if (field.hasOwnProperty('maxResponses') && currentResponse.length > field.maxResponses) {
            dispatch(validate.setResponseValidationError({message: "A maximum of " + field.maxResponses + " choices can be selected."}));
            return false;
        } else if (field.type === 'text-input' && field.isRequired && currentResponse[0].text === 'no answer') {
            dispatch(validate.setResponseValidationError({message: "An answer is required in order to proceed."}));
            return false;
        } else if (field.type === 'number-input') {
            const minValue = field.minValue || null;
            const maxValue = field.maxValue || null;
            const currentValue = parseInt(currentResponse[0].value, 10) || null;

            if (field.isRequired && !currentValue) {
                dispatch(validate.setResponseValidationError({message: "An answer is required in order to proceed."}));
                return false;
            } else if ((minValue && currentValue < minValue) || (maxValue && currentValue > maxValue)) {
                const errorMessage = `Please enter a value between ${minValue} and ${maxValue}`;
                dispatch(validate.setResponseValidationError({message: errorMessage}));
                return false;
            } else {
                dispatch(validate.clearResponseValidationError());
                return true;                
            }               
        } else if (field.type === 'matrix' && field.isRequired) {
            var currentResponseRowValues = _.map(currentResponse, 'rowValue');
            var questionValues = _.map(questionRows, 'value');
            var questionRowValues = _.map(questionRows, 'rowValue');
            var currentRowMatchesQuestionValue = _.xor(currentResponseRowValues, questionValues).length === 0;
            var currentValueMatchesQuestionValue = _.xor(currentResponseRowValues, questionRowValues).length === 0;            

            // Validate that all matrix rows are contained in currentResponse array
            if (currentRowMatchesQuestionValue || currentValueMatchesQuestionValue) {
                dispatch(validate.clearResponseValidationError());
                return true; 
            } else {
                dispatch(validate.setResponseValidationError({message: "Please make a selection for each row."}));
                return false;
            }
        } else {
            dispatch(validate.clearResponseValidationError());
            return true;
        }
    };

    return {
        isValidAnswer: _isValidAnswer
    };

})();

module.exports = responseUtils;



// WEBPACK FOOTER //
// ./src/common/modules/responses/utils.js